import { RouterProvider } from 'react-router-dom';

// project imports
import { LanguageProvider } from 'contexts/LanguageContext';
import router from 'routes';
import ThemeCustomization from 'themes';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <LanguageProvider>
        <RouterProvider router={router} />
      </LanguageProvider>
    </ThemeCustomization>
  );
}
